<template>
    <div class="Dicability">
        <a-tabs :default-active-key="activeKey" @change="callback" :animated="false">
            <a-tab-pane key="0" tab="通用能力">
                <a-card>
                    <a-button
                        style="margin-bottom: 15px;"
                        type="primary"
                        @click="add()"
                        icon="plus"
                        v-permission="`Content.DicAbility.Add`"
                        >添加能力维度</a-button>
                    <div class="table">
                        <a-table
                            class="components-table-demo-nested"
                            :columns="columns"
                            rowKey="id"
                            :loading="loading"
                            :dataSource="dataSource"
                            :pagination="false"
                            @expand="getRecord"
                            @expandedRowsChange="expandedRowsChange"
                            :expandedRowKeys="tableExpandedRowKeys"
                        >
                            <div slot="name" slot-scope="text, record" style="display:inline;">
                                <span v-if="record.abilityCode">{{record.name + '( ' + record.abilityCode + ' )'}}</span>
                                <span v-else>{{record.name}}</span>
                            </div>
                            <div slot="level" slot-scope="text, record">
                                <span>{{record.levelNumber == 0 ? ' - ' : record.levelNumber }}</span>
                            </div>
                            <div slot="abyType" slot-scope="text, record">
                                <span>{{record.levelNumber == 0 ? '综合能力' : record.levelNumber == 1 ? '一级能力' : '二级能力'}}</span>
                            </div>
                            <div slot="icon" slot-scope="text, record">
                                <img :src="record.icon | filterUrl" alt style="width:26px;height:26px;" v-if="record.icon">
                            </div>
                            <div
                                slot="color"
                                slot-scope="text, record"
                                style="display: flex;justify-content: center;"
                            >
                                <div style="width:50px;height:30px;" :style="{ background: record.color}"></div>
                            </div>
                            <div slot="status" slot-scope="text,record" v-auth="`Content.DicAbility.Enabled`">
                                <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.enabled" @click="StatusChange(record)"/>
                            </div>
                            <div slot="action" slot-scope="text, record" class="action">
                                <a @click="edit(record)" v-permission="`Content.DicAbility.Edit`">
                                    <a-icon type="edit"/>编辑
                                </a>
                                <a-popconfirm
                                    v-permission="`Content.DicAbility.Delete`"
                                    title="确认要删除此能力维度？"
                                    @confirm="del(text)"
                                    ok-text="确认"
                                    cancel-text="取消"
                                >
                                    <a class="red">
                                        <a-icon type="delete"/>删除
                                    </a>
                                </a-popconfirm>
                            </div>
                        </a-table>
                    </div>
                    <!-- 编辑添加 -->
                    <a-modal v-model="ismodle" :title="title" @ok="modleOk" @cancel="closeModle">
                        <a-form-model
                        ref="ruleForm"
                        :model="modleForm"
                        :rules="ruleForm"
                        :label-col="{span:6}"
                        :wrapper-col="{span:14}"
                        >
                        <a-form-model-item ref="name" label="能力名称(ZH)" prop="name">
                            <a-input v-model="modleForm.name" :disabled="isEdit"/>
                        </a-form-model-item>
                        <a-form-model-item ref="abilityCode" label="能力名称(EN)" prop="abilityCode">
                            <a-input v-model="modleForm.abilityCode"/>
                        </a-form-model-item>
                        <a-form-model-item ref="parentId" label="父能力" prop="parentId">
                            <a-tree-select
                            v-model="modleForm.parentId"
                            style="width: 100%"
                            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                            placeholder="选择父能力"
                            @change="pickParentId"
                            allow-clear
                            >
                            <a-tree-select-node key="0" value="0" title="添加能力类型"></a-tree-select-node>
                            <a-tree-select-node
                                :key="items.id"
                                :title="items.name"
                                :value="items.id"
                                :test="items.id"
                                v-for="items in dataSource"
                            >
                                <template v-if="items.children">
                                <a-tree-select-node
                                    :key="item.id"
                                    :title="item.name"
                                    :value="item.id"
                                    v-for="item in items.children"
                                >
                                    <template v-if="item.children">
                                    <a-tree-select-node
                                        :key="el.id"
                                        :title="el.name"
                                        :value="el.id"
                                        v-for="el in item.children"
                                    >
                                        <template v-if="el.children">
                                        <a-tree-select-node
                                            :key="cl.id"
                                            :title="cl.name"
                                            :value="cl.id"
                                            v-for="cl in el.children"
                                        />
                                        </template>
                                    </a-tree-select-node>
                                    </template>
                                </a-tree-select-node>
                                </template>
                            </a-tree-select-node>
                            </a-tree-select>
                        </a-form-model-item>
                        <a-form-model-item ref="levelNumber" label="能力等级" prop="levelNumber">
                            <a-input v-model="modleForm.levelNumber" disabled/>
                        </a-form-model-item>
                        <a-form-model-item ref="color" label="能力颜色" prop="color">
                            <div class="block">
                            <a-input v-model="modleForm.color" disabled/>
                            <el-color-picker v-model="modleForm.color"></el-color-picker>
                            </div>
                        </a-form-model-item>
                        <a-form-model-item ref="icon" label="能力图标" prop="icon" style="margin-bottom: 0px;">
                            <a-upload
                            name="imgFile"
                            list-type="picture-card"
                            class="avatar-uploader"
                            :show-upload-list="false"
                            :headers="headers"
                            :action=" baseURL"
                            @change="changeIcon"
                            :before-upload="beforeIcon"
                            >
                            <div v-if="modleForm.icon">
                                <a-icon
                                v-show="imgLoading"
                                style="position: absolute; top: 45%; left: 45%"
                                type="loading"
                                />
                                <img
                                style="max-width: 100px;max-height: 100px"
                                :src="modleForm.icon | filterUrl"
                                alt="avatar"
                                >
                            </div>
                            <div v-else>
                                <a-icon :type="iconloading ? 'loading' : 'plus'"/>
                            </div>
                            </a-upload>
                        </a-form-model-item>
                        <a-form-model-item ref="abilityClassify" label="能力分类" prop="abilityClassify">
                            <a-select allowClear v-model="modleForm.abilityClassify" placeholder="请选择能力分类">
                            <a-select-option :value="0">核心能力</a-select-option>
                            <a-select-option :value="1">扩展能力</a-select-option>
                            </a-select>
                        </a-form-model-item>
                        <a-form-model-item ref="shortdescription" label="短描述" prop="shortdescription">
                            <a-input v-model="modleForm.shortdescription"/>
                        </a-form-model-item>
                        <a-form-model-item ref="longdescription" label="长描述" prop="longdescription">
                            <a-input v-model="modleForm.longdescription"/>
                        </a-form-model-item>
                        </a-form-model>
                    </a-modal>
                </a-card>
            </a-tab-pane>
            <a-tab-pane key="1" tab="题目能力">
                <a-card>
                    <a-button
                        style="margin-bottom: 15px;"
                        type="primary"
                        @click="add()"
                        icon="plus"
                        v-permission="`Content.DicAbility.Add`"
                        >添加能力维度</a-button>
                    <div class="table">
                        <a-table
                            class="components-table-demo-nested"
                            :columns="columns"
                            rowKey="id"
                            :loading="loading"
                            :dataSource="dataSource"
                            :pagination="false"
                            @expand="getRecord"
                            @expandedRowsChange="expandedRowsChange"
                            :expandedRowKeys="tableExpandedRowKeys"
                        >
                            <div slot="name" slot-scope="text, record" style="display:inline;">
                                <span v-if="record.abilityCode">{{record.name + '( ' + record.abilityCode + ' )'}}</span>
                                <span v-else>{{record.name}}</span>
                            </div>
                            <div slot="level" slot-scope="text, record">
                                <span>{{record.levelNumber == 0 ? ' - ' : record.levelNumber }}</span>
                            </div>
                            <div slot="abyType" slot-scope="text, record">
                                <span>{{record.levelNumber == 0 ? '综合能力' : record.levelNumber == 1 ? '一级能力' : '二级能力'}}</span>
                            </div>
                            <div slot="icon" slot-scope="text, record">
                                <img :src="record.icon | filterUrl" alt style="width:26px;height:26px;" v-if="record.icon">
                            </div>
                            <div
                                slot="color"
                                slot-scope="text, record"
                                style="display: flex;justify-content: center;"
                            >
                                <div style="width:50px;height:30px;" :style="{ background: record.color}"></div>
                            </div>
                            <div slot="status" slot-scope="text,record" v-auth="`Content.DicAbility.Enabled`">
                                <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.enabled" @click="StatusChange(record)"/>
                            </div>
                            <div slot="action" slot-scope="text, record" class="action">
                                <a @click="edit(record)" v-permission="`Content.DicAbility.Edit`">
                                    <a-icon type="edit"/>编辑
                                </a>
                                <a-popconfirm
                                    v-permission="`Content.DicAbility.Delete`"
                                    title="确认要删除此能力维度？"
                                    @confirm="del(text)"
                                    ok-text="确认"
                                    cancel-text="取消"
                                >
                                    <a class="red">
                                        <a-icon type="delete"/>删除
                                    </a>
                                </a-popconfirm>
                            </div>
                        </a-table>
                    </div>
                    <!-- 编辑添加 -->
                    <a-modal v-model="ismodle" :title="title" @ok="modleOk" @cancel="closeModle">
                        <a-form-model
                        ref="ruleForm"
                        :model="modleForm"
                        :rules="ruleForm"
                        :label-col="{span:6}"
                        :wrapper-col="{span:14}"
                        >
                        <a-form-model-item ref="name" label="能力名称(ZH)" prop="name">
                            <a-input v-model="modleForm.name" :disabled="isEdit"/>
                        </a-form-model-item>
                        <a-form-model-item ref="abilityCode" label="能力名称(EN)" prop="abilityCode">
                            <a-input v-model="modleForm.abilityCode"/>
                        </a-form-model-item>
                        <a-form-model-item ref="parentId" label="父能力" prop="parentId">
                            <a-tree-select
                            v-model="modleForm.parentId"
                            style="width: 100%"
                            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                            placeholder="选择父能力"
                            @change="pickParentId"
                            allow-clear
                            >
                            <a-tree-select-node key="0" value="0" title="添加能力类型"></a-tree-select-node>
                            <a-tree-select-node
                                :key="items.id"
                                :title="items.name"
                                :value="items.id"
                                :test="items.id"
                                v-for="items in dataSource"
                            >
                                <template v-if="items.children">
                                <a-tree-select-node
                                    :key="item.id"
                                    :title="item.name"
                                    :value="item.id"
                                    v-for="item in items.children"
                                >
                                    <template v-if="item.children">
                                    <a-tree-select-node
                                        :key="el.id"
                                        :title="el.name"
                                        :value="el.id"
                                        v-for="el in item.children"
                                    >
                                        <template v-if="el.children">
                                        <a-tree-select-node
                                            :key="cl.id"
                                            :title="cl.name"
                                            :value="cl.id"
                                            v-for="cl in el.children"
                                        />
                                        </template>
                                    </a-tree-select-node>
                                    </template>
                                </a-tree-select-node>
                                </template>
                            </a-tree-select-node>
                            </a-tree-select>
                        </a-form-model-item>
                        <a-form-model-item ref="levelNumber" label="能力等级" prop="levelNumber">
                            <a-input v-model="modleForm.levelNumber" disabled/>
                        </a-form-model-item>
                        <a-form-model-item ref="color" label="能力颜色" prop="color">
                            <div class="block">
                            <a-input v-model="modleForm.color" disabled/>
                            <el-color-picker v-model="modleForm.color"></el-color-picker>
                            </div>
                        </a-form-model-item>
                        <a-form-model-item ref="icon" label="能力图标" prop="icon" style="margin-bottom: 0px;">
                            <a-upload
                            name="imgFile"
                            list-type="picture-card"
                            class="avatar-uploader"
                            :show-upload-list="false"
                            :headers="headers"
                            :action=" baseURL"
                            @change="changeIcon"
                            :before-upload="beforeIcon"
                            >
                            <div v-if="modleForm.icon">
                                <a-icon
                                v-show="imgLoading"
                                style="position: absolute; top: 45%; left: 45%"
                                type="loading"
                                />
                                <img
                                style="max-width: 100px;max-height: 100px"
                                :src="modleForm.icon | filterUrl"
                                alt="avatar"
                                >
                            </div>
                            <div v-else>
                                <a-icon :type="iconloading ? 'loading' : 'plus'"/>
                            </div>
                            </a-upload>
                        </a-form-model-item>
                        <a-form-model-item ref="abilityClassify" label="能力分类" prop="abilityClassify">
                            <a-select allowClear v-model="modleForm.abilityClassify" placeholder="请选择能力分类">
                            <a-select-option :value="0">核心能力</a-select-option>
                            <a-select-option :value="1">扩展能力</a-select-option>
                            </a-select>
                        </a-form-model-item>
                        <a-form-model-item ref="shortdescription" label="短描述" prop="shortdescription">
                            <a-input v-model="modleForm.shortdescription"/>
                        </a-form-model-item>
                        <a-form-model-item ref="longdescription" label="长描述" prop="longdescription">
                            <a-input v-model="modleForm.longdescription"/>
                        </a-form-model-item>
                        </a-form-model>
                    </a-modal>
                </a-card>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
import Apis from "@/requests/apis";
function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
}
const columns = [
    { title: "能力维度", scopedSlots: { customRender: "name" }, width: 250 },
    {
        title: "等级",
        scopedSlots: { customRender: "level" },
        align: "center",
        width: 80
    },
    {
        title: "能力类型",
        scopedSlots: { customRender: "abyType" },
        align: "center",
        width: 100
    },
    {
        title: "图标",
        scopedSlots: { customRender: "icon" },
        align: "center",
        width: 100
    },
    {
        title: "颜色",
        scopedSlots: { customRender: "color" },
        align: "center",
        width: 100
    },
    { title: "短描述", dataIndex: "shortdescription", align: "center" },
    {
        title: "长描述",
        dataIndex: "longdescription",
        align: "center",
        ellipsis: true
    },
    {
        title: "状态",
        scopedSlots: { customRender: "status" },
        align: "center",
        width: 120
    },
    {
        title: "操作",
        scopedSlots: { customRender: "action" },
        align: "center",
        width: 150
    }
];
export default {
  name: "Dicability",
  data() {
    return {
        advanced: false,
        istoggleAdvanced: false, //是否显示展开按钮
        columns: columns,
        loading: true,
        dataSource:[],
        activeKey:0,//选中的table
        ContentName: "",
        innerData: [],
        ismodle: false,
        modleForm: {
            name: "",
            abilityCode: "",
            parentId: undefined,
            levelNumber: "",
            color: "", //#1c97f5
            abilityClassify: undefined,
            shortdescription: "",
            longdescription: "",
            imgFile: "",
            icon: ""
        },
        ruleForm: {
            name: [
                { required: true, message: "请填写能力名称(ZH)", trigger: "blur" }
            ],
            abilityCode: [
                { required: true, message: "请填写能力名称(EN)", trigger: "blur" },
                {
                    required: true,
                    pattern: /^(\w|\s)+$/g,
                    message: "请填写英文名称",
                    trigger: "change"
                }
            ],
            parentId: [
                { required: true, message: "请选择父能力", trigger: "change" }
            ],
            levelNumber: [
                { required: true, message: "请填写能力等级", trigger: "blur" }
            ],
            color: [
                { required: true, message: "请选择能力颜色", trigger: "change" }
            ],
            icon: [
                { required: true, message: "请选择能力图标", trigger: "change" }
            ],
            abilityClassify: [
                { required: true, message: "请选择能力分类", trigger: "change" }
            ]
        },
        type: "",
        isEdit: false,
        statusType: "",
        allData: [],
        // icon
        iconloading: false,
        imgLoading: false,
        baseURL: process.env.VUE_APP_API_BASE_URL + Apis.File.upload + "?filePath=content/ability",
        headers: {
            Authorization: ""
        },
        tableExpandedRowKeys: [], //表格展开的行
        recordList: [],
        title: "",
        pageIndex: 1,
        pageSize: 10
    };
  },
    created() {
        let token = localStorage.getItem("token");
        this.headers.Authorization = "Bearer " + token;
        this.getList(this.activeKey);
    },
  watch: {
    "modleForm.color"() {
      if (this.modleForm.color) {
        this.$refs.ruleForm.validateField("color");
      }
    }
  },
  methods: {
    //切换tab
    callback(key){
        this.activeKey = key
        this.getList(key)
    },
    getRecord(expanded, record) {
      if (expanded) {
        // id = record.levelNumber
        if (record.levelNumber == 0) {
          this.recordList.push(record);
        }
      } else {
        if (record.levelNumber == 0) {
          this.recordList.pop(record);
        }
      }
    },
    // 展开行
    expandedRowsChange(expandedRowKeys) {
      setTimeout(() => {
        if (this.recordList.length > 1) {
          this.tableExpandedRowKeys = [expandedRowKeys.pop()];
          this.recordList.length = 1;
        } else {
          this.tableExpandedRowKeys = expandedRowKeys;
        }
      }, 10);
    },
    closeModle() {
      this.$refs.ruleForm.resetFields();
    },
    changeIcon(info) {
      if (info.fileList[0].response) {
        this.modleForm.icon = info.fileList[0].response.data;
      }
      if (info.file.status === "uploading") {
        this.iconloading = true;
        this.imgLoading = true;
        return;
      }
      if (info.file.status === "done") {
        // Get this url from response in real world.
        console.log(info.file.response.data);
        getBase64(info.file.originFileObj, imageUrl => {
          this.modleForm.icon = info.file.response.data;
          this.iconloading = false;
          this.imgLoading = false;
        });
      }
    },
    beforeIcon(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        this.$message.error("请上传jpg或者png图片!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图片大小不能超过2M!");
      }
      return isJpgOrPng && isLt2M;
    },
    pickParentId(value, label, extra) {
      if (label[0] == "添加能力类型") {
        this.modleForm.levelNumber = 0;
      } else {
        this.allData.forEach(item => {
          if (item.name == label[0]) {
            this.modleForm.levelNumber = item.levelNumber + 1;
          }
        });
      }
      this.$refs.ruleForm.validateField("levelNumber");
    },
    StatusChange(record) {
      this.loading = true;
      let formData = new FormData();
      formData.append("id", record.id);
      this.$http
        .abilityUpdatestatus(formData)
        .then(res => {
          this.loading = false;
            this.getList(this.activeKey);
            this.$message.destroy();
            this.$message.success("修改成功");
        
        })
        .catch(err => {
          this.loading = false;
        });
    },
    add() {
      this.type = "add";
      this.title = "添加";
      this.isEdit = false;
      this.ismodle = true;
      this.modleForm = {
        name: "",
        abilityCode: "",
        parentId: undefined,
        levelNumber: "",
        color: "",
        abilityClassify: undefined,
        shortdescription: "",
        longdescription: "",
        imgFile: "",
        icon: "",
        abilityType:this.activeKey
      };
    },
    edit(record) {
        console.log(record)
      this.type = "edit";
      this.title = "编辑";
      this.ismodle = true;
      //2021-11-12 10:13测试要求改为可编辑
      this.isEdit = false;
      this.modleForm.id = record.id;
      for (let key in record) {
        for (let k in this.modleForm) {
          if (key == k) {
            this.modleForm[key] = record[key];
          }
        }
      }
      this.modleForm.parentId = record.parentId == null ? 0 : this.modleForm.parentId;
      this.modleForm.abilityType = this.activeKey

    },
    del(val) {
      this.$confirm({
        title: `确认删除【${val.name}】`,
        content: "能力删除后所有能力相关数据都将删除且不可恢复，请谨慎操作",
        centered: true,
        onOk: () => {
          let formData = new FormData();
          formData.append("id", val.id);
          this.loading = true;
          this.$http.abilityDelete(formData).then(res => {
            const data = res.data;
              this.getList(this.activeKey);
              this.$message.success("删除成功");
          }).finally(() => {
            this.loading = false;
          })
        }
      });
    },
    modleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let formData = new FormData();
          formData.append("name", this.modleForm.name);
          formData.append("abilityCode", this.modleForm.abilityCode);
          formData.append(
            "parentId",
            this.modleForm.parentId == 0 ? "" : this.modleForm.parentId
          );
          formData.append("levelNumber", this.modleForm.levelNumber);
          formData.append("color", this.modleForm.color);
          formData.append("abilityClassify", this.modleForm.abilityClassify);
          formData.append("shortdescription", this.modleForm.shortdescription);
          formData.append("longdescription", this.modleForm.longdescription);
          formData.append("icon", this.modleForm.icon);
          formData.append("abilityType", this.modleForm.abilityType);
          if (this.type == "add") {
            this.abilityAdd(formData);
          } else {
            formData.append("id", this.modleForm.id);
            this.abilityEdit(formData);
          }
        } else {
        }
      });
    },
    abilityAdd(formData) {
      this.$http.abilityAdd(formData).then(res => {
          this.$message.success("添加成功");
          this.getList(this.activeKey);
          this.ismodle = false;
       
      });
    },
    abilityEdit(formData) {
      this.$http.abilityEdit(formData).then(res => {
          this.$message.success("修改成功");
          this.getList(this.activeKey);
          this.ismodle = false;
       
      });
    },
    getList(key) {
        let params = {
            abilityType:key
        };
        this.loading = true;
        this.$http.abilityList(params)
        .then(res => {
            this.allData = res.data.data;
            this.loading = false;
            let arr = [];
            res.data.data.forEach(item => {
              if (item.levelNumber == 0) {
                item.children = [];
                item.title = item.name;
                item.key = item.id;
                arr.push(JSON.parse(JSON.stringify(item)));
              }
            });
            arr.forEach(el => {
              res.data.data.forEach(item => {
                if (item.levelNumber == 1 && item.parentId == el.id) {
                  item.children = [];
                  item.title = item.name;
                  item.key = item.id;
                  el.children.push(JSON.parse(JSON.stringify(item)));
                }
              });
              el.children.forEach(cl => {
                res.data.data.forEach(item => {
                  if (item.levelNumber == 2 && item.parentId == cl.id) {
                    item.children = [];
                    item.title = item.name;
                    item.key = item.id;
                    cl.children.push(JSON.parse(JSON.stringify(item)));
                  }
                });
                cl.children.forEach(ccl => {
                  res.data.data.forEach(item => {
                    if (item.levelNumber == 3 && item.parentId == ccl.id) {
                      item.children = [];
                      item.title = item.name;
                      item.key = item.id;
                      ccl.children.push(JSON.parse(JSON.stringify(item)));
                    }
                  });
                });
              });
            });
            function recursion(arr) {
              for (let i = 0; i < arr.length; i++) {
                if (arr[i].children && arr[i].children.length) {
                  recursion(arr[i].children);
                } else {
                  delete arr[i].children;
                }
              }
            }
            recursion(arr);
            this.dataSource = arr;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 点击展开事件
    expand(expanded, record) {
      if (expanded) {
        let params = {
          code: record.code
        };
        this.$http.getContentsByCode(params).then(res => {
            this.innerData = res.data.data;
        });
      }
    }
  }
};
</script>

<style scoped lang="less">
.searchForm {
  display: flex;
  justify-content: space-between;
}
.fold {
  display: flex;
  align-items: center;
}
.t_top {
  display: flex;
  align-items: center;
}
.t_bot {
  span {
    margin-right: 25px;
    margin-top: 10px;
    display: inline-block;
  }
}
.block {
  display: flex;
}
/deep/ .el-color-picker__trigger {
  width: 32px;
  height: 32px;
}
/deep/ .ant-input-disabled {
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
}

/deep/ .ant-tabs-bar{
    background-color: #fff !important;
    border:none !important;
    margin-bottom: 0 !important;
}
/deep/ .ant-card {
    border-top:none !important;
}
</style>
